export default {
	title: "Grupos",
	newGroup: "Novo Grupo",
	editGroup: "Editar Grupo",
	deleteGroup: "Excluir Grupo",
	name: "Nome",
	description: "Descrição",
	color: "Cor",
	icon: "Ícone",
	members: "Membros",
	calendar: "Calendário",
	assignments: "Atividades",
	addMember: "Adicionar Membro",
	removeMember: "Remover Membro",
	removeMemberConfirm: "Tem certeza que deseja remover este membro do grupo?",
	deleteConfirm: "Tem certeza que deseja excluir o grupo \"{name}\"? Todos os membros serão desvinculados e todas as atividades e lembretes serão removidos. Esta ação não pode ser desfeita.",
	noMembers: "Nenhum membro neste grupo",
	noMembersText: "Adicione membros para organizar seu grupo",
	noAssignments: "Nenhuma atividade agendada",
	noAssignmentsText: "Adicione uma atividade usando o Calendário",
	selectDayHint: "Selecione um dia para ver ou adicionar uma atividade",
	emptyTitle: "Nenhum grupo cadastrado",
	emptyText: "Crie grupos para organizar os membros do seu terreiro",
	searchPlaceholder: "Buscar grupos...",
	status: {
		active: "Ativo",
		inactive: "Inativo",
	},
	filters: {
		status: "Status",
		active: "Ativos",
		inactive: "Inativos",
	},
	assignment: {
		new: "Nova Atividade",
		edit: "Editar Atividade",
		delete: "Excluir Atividade",
		deleteConfirm: "Tem certeza que deseja excluir esta atividade?",
		date: "Data",
		startTime: "Horário",
		description: "Descrição",
		linkRitual: "Vincular a ritual",
		selectRitual: "Selecionar ritual",
		reminder: "Enviar lembrete por email",
		reminderDays: "Dias antes",
		reminderHintSameDay: "No dia da atividade",
		reminderHint1Day: "1 dia antes",
		reminderHintDays: "{days} dias antes",
		reminderMessage: "Mensagem personalizada",
		reminderMessageHint: "Deixe em branco para usar o modelo padrão",
		addToDay: "Adicionar atividade",
		batchMode: "Múltiplos dias",
		batchDatesSelected: "{count} data(s) selecionada(s)",
		linkFirstRitual: "Vincular ao primeiro ritual de cada dia, se existente",
	},
	messages: {
		created: "Grupo criado com sucesso",
		updated: "Grupo atualizado com sucesso",
		deleted: "Grupo excluído com sucesso",
		memberAdded: "Membro adicionado com sucesso",
		memberRemoved: "Membro removido com sucesso",
		assignmentCreated: "Atividade criada com sucesso",
		assignmentUpdated: "Atividade atualizada com sucesso",
		assignmentDeleted: "Atividade excluída com sucesso",
		errorLoading: "Erro ao carregar dados",
	},
	stats: {
		total: "Total",
		active: "Ativos",
		totalMembers: "Membros",
	},
	validation: {
		nameRequired: "O nome do grupo é obrigatório",
		nameMaxLength: "O nome deve ter no máximo 150 caracteres",
	},
	activities: {
		tab: "Atividades",
		upcoming: "Próximas",
		past: "Anteriores",
		all: "Todas",
		linkedToRitual: "Vinculada a ritual",
		noActivities: "Nenhuma atividade encontrada",
		noActivitiesUpcoming: "Nenhuma atividade futura agendada",
		noActivitiesPast: "Nenhuma atividade anterior registrada",
		showMore: "Carregar mais",
	},
	weekDays: {
		sun: "Dom",
		mon: "Seg",
		tue: "Ter",
		wed: "Qua",
		thu: "Qui",
		fri: "Sex",
		sat: "Sáb",
	},
};
